module.exports = __webpack_public_path__ + "static/icons/icon-bell-7150041695a7cb92b2a28a3b1be75703.svg";